module.exports = __webpack_public_path__ + "img/sm.5fe07f82.png";